'use client'
import { createPageContentTelemetry } from '@brew/observability/browser'
import { PAGE_CONTENT_CONTRACTS } from './page-content-contracts.runtime.generated'
export const pageContentReadiness = createPageContentTelemetry(
  PAGE_CONTENT_CONTRACTS
)
